import { render, staticRenderFns } from "./paymentReview.vue?vue&type=template&id=45ea495f"
import script from "./paymentReview.vue?vue&type=script&lang=js"
export * from "./paymentReview.vue?vue&type=script&lang=js"
import style0 from "./paymentReview.vue?vue&type=style&index=0&id=45ea495f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports